import Page from '@/components/Page'
import Post from '@/components/Post'
import { getPage } from '@/contentful/getPages'
import { getPost, getPostBySlugHistory, getTopStories } from '@/contentful/getPosts'
import { getPostTags } from '@/contentful/getTags'
import { setMetaTags } from '@/src/components/utils/manage-tags'
import { getDictionary } from '@/src/dictionary'
import Head from 'next/head'
import { useRouter } from 'next/router'

export const getServerSideProps = async (context) => {

    let post = null
    let page = null
    let tags = null
    let topStories = null
    let host = context.req.headers.host

    const isPost = context.params.path === getDictionary('postsPath').replaceAll('/', '')

    if (isPost) {
        post = await getPost(context.params.slug)
        if (post) {
            topStories = await getTopStories(post.sys.id)
            tags = await getPostTags(post.metadata.tags)
        } else {
            const historyPost = await getPostBySlugHistory(context.params.slug)
            if (historyPost) {
                return {
                    redirect: {
                        destination: `${getDictionary('postsPath')}${historyPost.fields.slug}`,
                    }
                };
            } else {
                return { notFound: true }
            }
        }
    } else {
        page = await getPage(context.params.slug, context.params.path)
        if (!page) {
            return { notFound: true }
        }
    }

    return {
        props: {
            isPost,
            post: post ? post.fields : null,
            tags,
            topStories,
            page: page ? page : null,
            host
        },
    }
}

export default function Slug({ isPost, post, tags, topStories, page, host }) {
    const router = useRouter()
    return (
        <>
            <Head>
                {setMetaTags(host, { page: page, post: post }, router.asPath)}
            </Head>
            {
                isPost
                    ? <Post post={post} tags={tags} topStories={topStories} host={host} />
                    : <Page page={page} />
            }
        </>
    )
}
